export default __webpack_public_path__ + "static/media/icon_message-full.51df0a0a.svg";